// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/Inputs/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_Content_Settings_Content_Onboarding_Inputs{
  onboarding_inputs(order_by: { created_at: desc }) {
    id
    type
    inputs_url
    created_at
    created_by_name
    location {
      id
      name
    }
    status
    message
  }
}

`